import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import CardFace from '../Card/CardFace';
import { selectHand } from '../ActiveGame/selectors';

/** Up to this many cards are drawn in the fan; the count says the rest. */
const MOST_SHOWN = 7;
/** How far apart the fanned cards turn, in degrees. */
const SPREAD = 9;

const Fan = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  --card-w: 100%;
`;

const Back = styled.div`
  position: absolute;
  inset: 0;
  transform-origin: 50% 120%;
`;

const Count = styled.span`
  position: absolute;
  left: 50%;
  bottom: -6px;
  transform: translateX(-50%);
  min-width: 20px;
  padding: 1px 6px;
  border-radius: 10px;
  background: rgba(10, 18, 14, .9);
  color: #f4f1e8;
  font-size: 11px;
  font-weight: 800;
  text-align: center;
`;

/** A fan of `count` card backs and how many: the opponent's hand, face down. */
export const HandFan = ({ count }) => {
  const shown = Math.min(count, MOST_SHOWN);

  return (
    <Fan role="img" aria-label={`Your opponent's hand: ${count} ${count === 1 ? 'card' : 'cards'}`}>
      {Array.from({ length: shown }, (_, i) => (
        <Back key={i} style={{ transform: `rotate(${(i - (shown - 1) / 2) * SPREAD}deg)` }}>
          <CardFace />
        </Back>
      ))}
      {count > 0 && <Count>{count}</Count>}
    </Fan>
  );
};

HandFan.propTypes = {
  count: PropTypes.number.isRequired,
};

/**
 * The opponent's hand, face down, held past the far edge of the board where they sit: a fan of card backs and how
 * many. Their draws fly here (Motion/anchorNames hand).
 */
const OpponentHand = ({ userId }) => {
  const hand = useSelector((state) => selectHand(state, { userId }));
  return <HandFan count={hand ? hand.get('count') : 0} />;
};

OpponentHand.propTypes = {
  userId: PropTypes.number.isRequired,
};

export default OpponentHand;
